import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Loading from '../components/Loading';
import customContainers from 'constants/configWrappersList';
import { createStructuredSelector } from 'reselect';
import { adminConfigSelector, getAdminConfig } from '../utils/selectors/adminConfigSelector';
import { flow } from 'lodash';

const configWrapper = (node) => {
  class ConfigWrapper extends Component {
    static propTypes = {
      adminConfig: PropTypes.object,
      isLoading: PropTypes.bool,
      isError: PropTypes.bool,
    };

    render() {
      const { adminConfig, isLoading, isError } = this.props;
      const key = node.key;
      if (isLoading) return <Loading />;
      if (isError || !adminConfig[key]) return node;
      if (adminConfig[key]) {
        const Wrapper = customContainers[adminConfig[key].objectType](node);
        return <Wrapper adminConfig={adminConfig[key]} />;
      }
    }
  }

  const mapStateToProps = createStructuredSelector({
    adminConfig: adminConfigSelector,
    isLoading: flow(getAdminConfig, (adminConfig) => adminConfig.get('loading')),
    isError: flow(getAdminConfig, (adminConfig) => adminConfig.get('error')),
  });
  return connect(mapStateToProps)(ConfigWrapper);
};

configWrapper.propTypes = {};

export default configWrapper;
